import { LoadingButton } from "@mui/lab";
import { Alert, Grid, MenuItem, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createLocationThunk,
  updateLocationThunk,
} from "store/reducers/inventory/locationSlice";
import * as yup from "yup";

const validation = yup.object({
  name: yup.string().required("Name required"),
  desc: yup.string().nullable(),
  gst: yup.string().nullable(),
  va_no: yup.string().nullable(),
  maintain_stock: yup.boolean().required(),
});
const LocationCreate = ({ location, fullGrid }) => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: location?.name ?? "",
      desc: location?.desc ?? "",
      gst: location?.gst ?? "",
      va_no: location?.va_no ?? "",
      maintain_stock: location?.maintain_stock ?? false,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      if (location) {
        dispatch(updateLocationThunk({ id: location.id, data }));
      } else {
        dispatch(createLocationThunk(data));
      }
    },
    validateOnChange: false,
  });
  const { loading, success, errorMessage, error } = useSelector(
    (state) => state.location
  );
  useEffect(() => {
    if (errorMessage?.create) {
      Object.keys(errorMessage.create).forEach((key) => {
        console.log(key, errorMessage.create[key][0]);
        formik.setFieldError(key, errorMessage.create[key][0]);
      });
    }

    if (errorMessage?.update) {
      Object.keys(errorMessage.update).forEach((key) => {
        console.log(key, errorMessage.update[key][0]);
        formik.setFieldError(key, errorMessage.update[key][0]);
      });
    }
  }, [errorMessage]);
  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={1} paddingY={1}>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="Name"
            variant="outlined"
            name="name"
            fullWidth
            value={formik.values.name}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.name)}
            helperText={formik.errors.name}
            autoComplete="new-password"
            required
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="Desc"
            variant="outlined"
            name="desc"
            fullWidth
            value={formik.values.desc}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.desc)}
            helperText={formik.errors.desc}
            autoComplete="new-password"
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="Gst"
            variant="outlined"
            name="gst"
            fullWidth
            value={formik.values.gst}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.gst)}
            helperText={formik.errors.gst}
            autoComplete="new-password"
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="VA no"
            variant="outlined"
            name="va_no"
            fullWidth
            value={formik.values.va_no}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.va_no)}
            helperText={formik.errors.va_no}
            autoComplete="new-password"
          />
        </Grid>
        <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
          <TextField
            label="Maintain stock"
            variant="outlined"
            name="maintain_stock"
            fullWidth
            value={formik.values.maintain_stock}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.maintain_stock)}
            helperText={formik.errors.maintain_stock}
            autoComplete="new-password"
            select
          >
            <MenuItem value={true}>True</MenuItem>
            <MenuItem value={false}>False</MenuItem>
          </TextField>
        </Grid>
      </Grid>
      {(error?.create || error?.update) && (
        <Alert sx={{ my: 1 }} severity="error">
          Error occurred
        </Alert>
      )}

      {(success?.create || success?.update) && (
        <Alert sx={{ my: 1 }} severity="success">
          Success
        </Alert>
      )}
      <LoadingButton
        loading={loading?.create || loading?.update}
        variant="contained"
        type="submit"
        sx={{ paddingX: 10, marginTop: 1 }}
      >
        {location ? "Update location" : "Create location"}
      </LoadingButton>
    </form>
  );
};

export default LocationCreate;
